webpackJsonp([86],{

/***/ 1341:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_TabsComponent__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_TabsComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_TabsComponent__);
//
//
//
//
//
//
//




function data() {
	return {
		tabs: [{
			id: 1,
			title: 'Perdidos',
			link: { name: 'lost' }
		}, {
			id: 2,
			title: 'Encontrados',
			link: { name: 'found' }
		}]
	};
}

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'lost-found-container',
	components: {
		TabsComponent: __WEBPACK_IMPORTED_MODULE_0__components_shared_TabsComponent___default.a
	},
	data: data
});

/***/ }),

/***/ 1688:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('tabs-component', {
    attrs: {
      "tabs": _vm.tabs
    }
  }), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 847:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1341),
  /* template */
  __webpack_require__(1688),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/86.9336a1b332e1b01d475b.js